import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { Switch } from 'react-router-dom';
import { CompatRoute, CompatRouter } from 'react-router-dom-v5-compat';
import { ConnectedRouter } from 'connected-react-router/immutable';
import { I18nextProvider } from 'react-i18next';
import ConfigProvider from 'antd/es/config-provider';

import i18n, { i18nInitOptions, i18nPostInit } from 'i18n/i18n';
import { THEME } from 'op-themes';
import { configureStore } from 'store/index';
import appReducer from 'routes/AppContainer/reducer';

import history from '../app/history';

import { App } from './components/App';

import 'shims';
import 'importMinimalAssets';

i18n.init(i18nInitOptions);

i18nPostInit(i18n);

// We need to inject the app reducer for now to have uniform alerts
const store = configureStore({}, { app: appReducer }) as Store;

const container = document.getElementById('root');
/**
 * Using a router so we have access to apis like useLocation which will be used in the SSO flow.
 * Right now this is still just 1 route as we want to keep the base `signin` path so that users
 * don't accidentally navigate to /login
 */
if (container) {
  const root = createRoot(container);
  root.render(
    <I18nextProvider defaultNS="translation" i18n={i18n}>
      <ConfigProvider theme={THEME.dark}>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <CompatRouter>
              <Switch>
                <CompatRoute path="/signin">
                  <App />
                </CompatRoute>
              </Switch>
            </CompatRouter>
          </ConnectedRouter>
        </Provider>
      </ConfigProvider>
    </I18nextProvider>,
  );
}
